import { c as _c } from "react/compiler-runtime";
import snappPayLogo from "@website/accommodation-ui/hotel-snapp-pay/assets/snapp_pay_logo.png";
import { SnappPayDetailsModal } from "@website/accommodation-ui/hotel-snapp-pay/components/SnappPayDetailsModal";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { FC, useState } from "react";
export const HotelSnappPayDraft: FC = () => {
  const $ = _c(7);
  const [open, isOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      isOpen(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const toggleModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: "linear-gradient(90deg, #148EEB 0%, #76B4FD 100%)"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LazyImage fetchPriority="high" height={48} src={snappPayLogo.src} width={48} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-row items-center gap-2">{t2}<div className="flex flex-col gap-1 text-white"><p className="text-sm font-semibold">امکان رزرو ۴قسطه بدون ضامن، چک و سفته</p><span className="text-xs font-light">با انتخاب درگاه اسنپ‌پی هنگام پرداخت</span></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="px-6 lg:px-0"><div className="flex w-full flex-col items-start rounded-lg p-2 md:flex-row md:items-center md:justify-between md:p-3" style={t1}>{t3}<div className="pr-11 md:pr-0"><Button EndIcon={<MaterialIcon name="chevron_left" />} className="!font-light !text-white" onClick={toggleModal} size="small" type="button" variant="text">جزییات بیشتر</Button></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== open) {
    t5 = <>{t4}<SnappPayDetailsModal onClose={toggleModal} open={open} /></>;
    $[5] = open;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
function _temp(previous) {
  return !previous;
}